import axios from 'axios';

const getGeolocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject(new Error("La géolocalisation n'est pas supportée par ce navigateur."));
    }

    const options = {
      enableHighAccuracy: true, // Précision élevée
      timeout: 5000,            // Timeout de 5 secondes
      maximumAge: 0             // Ne pas utiliser une position mise en cache
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const geo = { latitude: position.coords.latitude, longitude: position.coords.longitude };
        resolve(geo);
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            reject(new Error("L'utilisateur a refusé la demande de géolocalisation."));
            break;
          case error.POSITION_UNAVAILABLE:
            reject(new Error("Les informations de localisation sont indisponibles."));
            break;
          case error.TIMEOUT:
            reject(new Error("La demande de géolocalisation a expiré."));
            break;
          default:
            reject(new Error(`Erreur de géolocalisation : ${error.message}`));
            break;
        }
      },
      options
    );
  });
};

const getAddressFromCoordinates = async () => {
    let coords = await getGeolocation();
    let latitude = coords.latitude;
    let longitude = coords.longitude;
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`;

    try {
        const response = await axios.get(url);
        if (response.status === 200) {
        const address = response.data.address;
        return address;
        } else {
        throw new Error('Impossible de récupérer l\'adresse.');
        }
    } catch (error) {
        throw new Error(`Erreur lors de la récupération de l'adresse : ${error.message}`);
    }
};

export default getAddressFromCoordinates;